import React, { useState, useMemo, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    Collapse,
    Box,
    IconButton,
    Button,
    Select,
    MenuItem,
    Typography,
    Pagination,
    Skeleton

} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FilterDataTable from "./FilterDataTable";
import ManageColumns from "./ManageColumns";
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandRowTable from "./ExpandRowTable";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from "react-redux";
import { jsonParserFormatter } from "../../utils/helperFunction";
import { useDispatch } from "react-redux";
import { setFilterField } from "../../containers/filter-container/reducer/filterSlice";
import { defaultPaginationValues } from "../../utils/constant";


const CommonDataTable = ({ columns = [], rows = [], idKey = "id",handleFilterApply,pageFilters, handleFliterSliceChange, loading, rowCount,otherPath }) => {
    const LOCAL_STORAGE_KEY = otherPath ? `${window.location.pathname}_${otherPath}` :  window.location.pathname;
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState("asc");
    const [expandedRows, setExpandedRows] = useState({});
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [filterColumn, setFilterColumn] = useState(null);
    const currentPageSize = pageFilters?.pageSize || defaultPaginationValues?.pageSize
    const currentPage = (pageFilters?.page || defaultPaginationValues?.page) + 1
    const totalPages = Math.ceil(rowCount / currentPageSize);
    const tableContainerRef = useRef(null);
    const scrollRef = useRef(null);
    const [scrollWidth, setScrollWidth] = useState(0);

    //  Load visible columns from localStorage OR use all columns initially
    const [visibleColumns, setVisibleColumns] = useState(() => {
        const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch {
                return columns.map(c => c.headerName);
            }
        }
        return columns.map(c => c.headerName);
    });

    useEffect(()=>{
        const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
        setVisibleColumns(saved ? JSON.parse(saved) :columns.map(c => c.headerName))
    },[otherPath])
    
    //  visible columns whenever changed
    useEffect(() => {
        if (visibleColumns.length) {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(visibleColumns));
        }
    }, [visibleColumns,otherPath]);



    // Filter visible columns
    const filteredColumns = columns.filter(col => visibleColumns.includes(col.headerName));



    // const handleFliterSliceChange =(values={})=>{
    //     let isQuery = typeof values==="object" && Object.keys(values)?.length
    //     isQuery && dispatch(setFilterField({pathname:locationFilterType,filters:JSON.stringify({...pageFilters,...defaultPaginationValues,...values})}))
    // }

    const handleSort = (col) => {
        const field = col.field
        const isAsc = orderBy === field && order === "asc";
        const selectedOrder = isAsc ? "desc" : "asc"
        setOrder(selectedOrder);
        handleFliterSliceChange({sortField:col?.filterColumnName,sortBy:selectedOrder})
        setOrderBy(field);
    };

    //pagination handlers
    const handlePageChange = (event, value) => {
         handleFliterSliceChange({pageSize:currentPageSize || defaultPaginationValues?.pageSize,page: value - 1})
    };

    const handleRowsPerPageChange = (event) => {
         handleFliterSliceChange({ pageSize: parseInt(event.target.value, 10),page:0})
    };


    const handleToggleRow = (rowKey) => {
        setExpandedRows((prev) => {
            const isCurrentlyExpanded = prev[rowKey];
            // Collapse all others; expand only the clicked one
            return isCurrentlyExpanded ? {} : { [rowKey]: true };
        });
    };


    const handleFilterClick = (event, column) => {
        setFilterAnchorEl(event.currentTarget);
        setFilterColumn(column);
    };

    const handleFilterClose = () => {
        setFilterAnchorEl(null);
        setFilterColumn(null);
    };


    // set widths
    useEffect(() => {
        if (tableContainerRef.current) {
            setScrollWidth(tableContainerRef.current.scrollWidth);
        }
    }, [columns, rows]);

    //  scrolling both ways
    const handleScroll = () => {
        if (tableContainerRef.current && scrollRef.current) {
            scrollRef.current.scrollLeft = tableContainerRef.current.scrollLeft;
        }
    };

    const handleBottomScroll = () => {
        if (tableContainerRef.current && scrollRef.current) {
            tableContainerRef.current.scrollLeft = scrollRef.current.scrollLeft;
        }
    };

    const handleFilterEnable = ()=>{
        if(filtersEnabled){
            handleFliterSliceChange(defaultPaginationValues,true)
        }
        setFiltersEnabled(!filtersEnabled)
    }

    useEffect(() => {
        if (pageFilters && typeof pageFilters == "object") {
            const avoidKeys = ["sortField", "sortBy", ...Object.keys(defaultPaginationValues)]
            const isFilter = Object.keys(pageFilters).filter(key => !avoidKeys.includes(key)).length
            setFiltersEnabled(Boolean(isFilter))
        }
    }, [pageFilters])

    // if (loading) {
    //     return (
    //         <Box sx={{ padding: 2 }}>
    //             {/* Toolbar skeleton */}
    //             <Box sx={{ display: "flex", justifyContent: "end", padding: "10px 15px", gap: '10px' }}>
    //                 <Skeleton variant="rounded" width={140} height={36} />
    //                 <Skeleton variant="rounded" width={140} height={36} />
    //             </Box>

    //             {/* Table skeleton */}
    //             <Paper sx={{ p: 2 }}>
    //                 <Table>
    //                     <TableHead>
    //                         <TableRow>
    //                             {(columns.length > 0 ? columns : [...Array(6)]).map((_, i) => (
    //                                 <TableCell key={i}>
    //                                     <Skeleton width={100} />
    //                                 </TableCell>
    //                             ))}
    //                         </TableRow>
    //                     </TableHead>
    //                     <TableBody>
    //                         {[...Array(10)].map((_, i) => (
    //                             <TableRow key={i}>
    //                                 {(columns.length > 0 ? columns : [...Array(6)]).map((_, j) => (
    //                                     <TableCell key={j}>
    //                                         <Skeleton width="90%" />
    //                                     </TableCell>
    //                                 ))}
    //                             </TableRow>
    //                         ))}
    //                     </TableBody>
    //                 </Table>
    //             </Paper>
    //         </Box>
    //     );
    // }

    // console.log("currentPageSize",currentPageSize);
    
    return (
        <>
            {/* Toolbar */}
            <Box sx={{ display: "flex", justifyContent: "end", padding: "10px 15px", gap: '10px' }}>
                <ManageColumns
                    widgetOptions={columns.map(c => c.headerName)}
                    defaultSelected={visibleColumns}
                    onChange={setVisibleColumns}
                />
                <Button
                    variant="contained"
                    onClick={handleFilterEnable}
                    sx={{
                        textTransform: "capitalize",
                        color: '#000',
                        background: !filtersEnabled ? 'none' : 'none',
                        width: '145px',
                        boxShadow: 'none',
                        border: !filtersEnabled ? '1px solid #ddd' : '1px solid #bf0e0e',
                        borderRadius: '40px',
                    }}>
                    {
                        filtersEnabled ? <CloseIcon sx={{ fontSize: '22px' }} /> : <FilterListIcon sx={{ fontSize: '22px' }} />
                    }
                    {filtersEnabled ? "Clear Filter" : " Filter"}
                </Button>
            </Box >

            {/* Table */}
            < Box sx={{ position: 'relative' }
            }>
                <TableContainer component={Paper}
                    ref={tableContainerRef}
                    onScroll={handleScroll}
                    sx={{
                        maxHeight: 600,
                        "&::-webkit-scrollbar": { height: 0 },
                    }}
                >
                    <Table sx={{ '& tbody, td, tfoot, th, thead, tr': { textWrap: 'nowrap' } }}>
                        <TableHead sx={{
                            position: 'sticky',
                            top: '0',
                            zIndex: '999'
                        }}>
                            <TableRow>
                                {filteredColumns.map(col => (
                                    <TableCell key={col.field} sortDirection={pageFilters?.sortField === col?.filterColumnName ? pageFilters?.sortBy : false}
                                        sx={{ width: col.width || "auto", fontWeight:"normal", background: "#f5f5f5" }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            {col?.filterable !== false ? <TableSortLabel
                                                active={pageFilters?.sortField && pageFilters?.sortField === col?.filterColumnName}
                                                direction={pageFilters?.sortField === col?.filterColumnName ? pageFilters?.sortBy : "asc"}
                                                onClick={() => handleSort(col)}
                                            >
                                                {col?.headerName}
                                            </TableSortLabel>
                                                : col?.headerName}
                                            
                                            {
                                                Object.keys(pageFilters || {}).includes(col?.filterColumnName) ? (
                                                    <IconButton size="small">
                                                        <FilterAltOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                ) : (
                                                    ''
                                                )
                                            }

                                            {filtersEnabled && col?.filterable!==false && (
                                                <IconButton size="small" onClick={(e) => handleFilterClick(e, col)}>
                                                    <MoreVertIcon fontSize="small" />
                                                </IconButton>
                                            )}

                                        </Box>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading ? [...Array(10)].map((_, i) => (
                                <TableRow key={i}>
                                    {(columns.length > 0 ? columns : [...Array(6)]).map((_, j) => (
                                        <TableCell key={j}>
                                            <Skeleton width="90%" />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                                : (
                                    rows?.length > 0 ? (
                                        rows?.map((row, index) => {
                                            const uniqueKey = row[idKey] ?? index;
                                            return (
                                                <React.Fragment key={uniqueKey}>
                                                    <TableRow>
                                                        {filteredColumns.map(col => {
                                                            const cellValue = row[col.field];
                                                            const uniqueFieldKey = row.id ? `${row.id}_${col.field}` : `${index}_${col.field}`;
                                                            return (
                                                                <TableCell key={col.field} sx={{alignContent:'center'}}>
                                                                    {col.renderCell
                                                                        ? col.renderCell({
                                                                            value: cellValue,
                                                                            row,
                                                                            toggleExpand: () => handleToggleRow(uniqueFieldKey),
                                                                            isExpanded: expandedRows[uniqueFieldKey] || false
                                                                        })
                                                                        : cellValue ?? ""}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>

                                                    {filteredColumns?.filter(ele => ele?.children).map(col => {
                                                        const uniqueFieldKey = row.id ? `${row.id}_${col.field}` : `${index}_${col.field}`;
                                                        return (
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={filteredColumns.length}
                                                                    sx={{ paddingBottom: 0, paddingTop: 0, background: "#fafafa", padding: '0' }}
                                                                >
                                                                    <Collapse in={expandedRows[uniqueFieldKey] || false} timeout="auto" unmountOnExit>
                                                                        <Box sx={{ padding: 0 }}>
                                                                            {expandedRows[uniqueFieldKey] && col?.children(col, row)}
                                                                        </Box>
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={columns.length} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    )
                                )
                            }





                        </TableBody>
                    </Table>
                </TableContainer>
                {/* Custom Pagination */}
               {!loading && <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: 'rgb(255, 255, 255)',
                        position: 'sticky',
                        bottom: '8px',
                        borderTop: '1px solid rgb(221, 221, 221)',
                        padding: '9px'

                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="body2">Rows per page:</Typography>
                        <Select
                            value={currentPageSize}
                            onChange={handleRowsPerPageChange}
                            size="small"
                        >
                            {[10, 20, 50, 100].map(opt => (
                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                            ))}
                        </Select>
                    </Box>

                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                        siblingCount={1}
                        boundaryCount={1}
                    />
                </Box>}
                {/* Fixed Bottom Scrollbar */}
                <Box
                    ref={scrollRef}
                    onScroll={handleBottomScroll}
                    sx={{
                        width: "100%",
                        overflowX: "auto",
                        position: "sticky",
                        bottom: 0,
                        // height: 12,
                        bgcolor: "#fafafa",
                        "&::-webkit-scrollbar": {
                            height: 8,
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#b0b0b0",
                            borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: "#909090",
                        },
                    }}
                >
                    <Box sx={{ width: scrollWidth, height: 8 }} />
                </Box>
            </Box >


            {/* Filter Popover */}
            < FilterDataTable
                filterAnchorEl={filterAnchorEl}
                filterColumn={filterColumn}
                handleFilterClose={handleFilterClose}
                // rows={filteredRows.length ? filteredRows : rows} //full dataset for filtering
                handleFilterApply={handleFilterApply}
                pageFilters={pageFilters}
                handleFliterSliceChange={handleFliterSliceChange}
            />
        </>
    );
};
export default CommonDataTable;